import {useDispatch} from 'react-redux';
import {useApiMutation} from 'src/hooks/useApiMutation';
import * as reduxApi from 'src/utils/redux-api-v2';
import {BYOD_API_BASE as BASE} from 'src/components/analytics-genesis/byod/api';
import {useByodMutationErrorHandler} from 'src/components/analytics-genesis/byod/api/error-handling';


export function useDeleteDashboard() {
  const dispatch = useDispatch();
  const onError = useByodMutationErrorHandler('delete dashboard');

  return useApiMutation<void, Error, {dashboardId: string}>({
    mutationFn: ({dashboardId}) => {
      const encodedId = encodeURIComponent(dashboardId);
      return dispatch(
        reduxApi.del(`${BASE}/dashboards/${encodedId}`),
      ) as Promise<void>;
    },
    onError,
  });
}
